import { Diagnosis, HandlerType, ReducerType, Session, TreatmentApproach } from '@uplift/types';
import { SessionResource } from '@uplift/api';
import React from 'react';


export type ClinicalNotesContextDataType = {
  appointment: Session;
  diagnoses: Diagnosis[];
  treatments: TreatmentApproach[];
  sessionResource: SessionResource;
  previousSessionResource?: SessionResource | null;
};

export type ClinicalNotesContextStateType = {
  state: ClinicalNotesContextDataType;
  dispatch: React.Dispatch<Action>;
};

export type InitAction = {
  type: 'init';
  payload: ClinicalNotesContextDataType;
};

export type UpdateSessionResourceAction = {
  type: 'updateSessionResource';
  payload: Pick<ClinicalNotesContextDataType, 'sessionResource'>;
};

type Action =
    | InitAction
    | UpdateSessionResourceAction;

const handlers: HandlerType<ClinicalNotesContextDataType, Action> = {
  init: (state, action: InitAction) => ({
    ...state,
    appointment: action.payload.appointment,
    diagnoses: action.payload.diagnoses,
    treatments: action.payload.treatments,
    sessionResource: action.payload.sessionResource,
    previousSessionResource: action.payload.previousSessionResource,
  }),
  updateSessionResource: (state, action: UpdateSessionResourceAction) => ({
    ...state,
    sessionResource: action.payload.sessionResource
  })
};


export const clinicalNotesReducer: ReducerType<ClinicalNotesContextDataType, Action> = (state, action) =>
  handlers[action.type]
    ? handlers[action.type](state, action)
    : state;


export const ClinicalNotesContext = React.createContext<ClinicalNotesContextStateType | null>(null);

export const useClinicalNotesContext = () => React.useContext(ClinicalNotesContext);
